import React from "react";
import { Button, Flex, FloatButton, Grid, Modal, Popover, Progress, Space, Steps, Typography, notification } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { EntidadeDependenciaService } from "../Services/EntidadeDependenciaService";
import { TypeEntidadeDependencia } from "../Models/EntidadeDepedencia";
import { CloseCircleOutlined, FileExclamationOutlined, FileSyncOutlined, MehOutlined, SmileOutlined } from "@ant-design/icons";

const { useBreakpoint } = Grid;
const EntidadeService = new EntidadeDependenciaService();

//Falta colocar o aviso para quando a pessoa acessa uma pagiona fora da parametrização
export function GuiaCadastral() {
    const tamanhoDaTela = useBreakpoint();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const [dependencias, setDependencias] = useState<TypeEntidadeDependencia[] | undefined>(undefined);
    const [rotaFinal, setRotaFinal] = useState("");
    const [passoAtual, setPassoAtual] = useState<TypeEntidadeDependencia | undefined>(undefined);

    const { data: dataTela, isFetching: isFetchingTela } = useQuery({
        queryKey: ['listarDependencia', pathname],
        queryFn: () => EntidadeService.listarDependencias({ rota: pathname } as TypeEntidadeDependencia),
        enabled: !dependencias || dependencias?.some(d => d.rota !== pathname),
        refetchOnWindowFocus: false
    });

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPopOpen, setIsPopOpen] = useState(true);

    const showModal = () => {
        setIsModalOpen(true);
        setIsPopOpen(false);
    };

    const handleFechar = () => {
        setIsModalOpen(false);
    };

    const handleParametrizar = () => {
        setDependencias(dataTela!.data);
        setPassoAtual(dataTela!.data.filter(d => d.feito === false).at(0)!);
        setRotaFinal(pathname);

        setIsModalOpen(false);
        navigate(dataTela?.data.filter(d => d.feito === false)[0].rota ?? "");
    };

    const ModalDependenciasTela = (props: { dependencias: TypeEntidadeDependencia[], exibePopOver: boolean }) => {
        return (
            <>
                <Popover
                    title={
                        <Flex justify="space-between">
                            Atenção
                            <Button type="link" style={{ padding: 0 }} onClick={() => setIsPopOpen(false)}>
                                <CloseCircleOutlined style={{ color: "crimson", fontSize: "16px" }} />
                            </Button>
                        </Flex>
                    }
                    content={<Space>Para utilizar esta tela existem outros cadastros a serem efetuados.</Space>}
                    open={isPopOpen && props.exibePopOver}
                >
                    <FloatButton
                        type="primary"
                        style={{ bottom: document.getElementsByClassName("btnAjuda").length > 0 ? 96 : 48 }}
                        icon={<FileExclamationOutlined />}
                        badge={{ count: props.dependencias.filter(d => d.feito === false).length }}
                        onClick={showModal}
                    />
                </Popover>
                <Modal
                    title="Parametrização necessária"
                    open={isModalOpen}
                    onCancel={handleFechar}
                    onOk={handleParametrizar}
                    cancelText="Fechar"
                    okText="Parametrizar"
                    footer={(_, { OkBtn, CancelBtn }) => <Flex justify="space-between"><CancelBtn /><OkBtn /> </Flex>}>
                    <>
                        <Typography>Para utilizar esta tela antes é necessário realizar a parametrização dos itens abaixo</Typography>
                        <Progress percent={Math.round((100 / props.dependencias.length) * props.dependencias.filter(d => d.feito === true).length)} />
                        <Steps
                            style={{ marginTop: 16, maxHeight: '300px', overflow: 'auto' }}
                            direction="vertical"
                            items={props.dependencias?.map(d => {
                                return {
                                    title: d.descricao,
                                    status: d.feito ? "finish" : "process",
                                    onClick: () => { navigate(d.rota); },
                                    style: { cursor: "pointer" }
                                }
                            })}
                        />
                    </>
                </Modal>
            </>
        )
    }

    const mutationVerificarPassoAtual = useMutation({
        mutationFn: (codigoPasso: number) => EntidadeService.verficarEntidade({ codigo: codigoPasso } as TypeEntidadeDependencia),
        onSuccess: (data) => {
            if (data.data.feito) {
                //Proximo passo
                if (passoAtual!.codigo !== dependencias!.findLast((d: TypeEntidadeDependencia) => d.feito === false)?.codigo) {
                    const proximoPasso = dependencias!.find((d: TypeEntidadeDependencia) => d.feito === false && d.codigo !== passoAtual!.codigo);
                    setDependencias(dependencias!.map(d => d.codigo === passoAtual?.codigo ? { ...d, feito: true } : d))
                    setPassoAtual(proximoPasso);
                    navigate(proximoPasso!.rota);
                }
                //Conclusão
                else {
                    setDependencias(undefined);
                    setPassoAtual(undefined);
                    navigate(rotaFinal);
                    notification.open({
                        message: 'As parametrizações necessarias foram concluidas.',
                        icon: <SmileOutlined style={{ color: 'green' }} />,
                        placement: 'topRight'
                    })
                }
            }
            else {
                notification.open({
                    message: 'O cadastro do passo atual ainda não foi concluido.',
                    icon: <MehOutlined style={{ color: 'red' }} />,
                    placement: 'topRight'
                })
            }
            setIsModalOpen(false);
        },
        onError: () => {
            notification.open({
                message: 'Ocorreu um erro, tente novamente mais tarde...',
                icon: <MehOutlined style={{ color: 'red' }} />,
                placement: 'topRight'
            })
        }
    })

    const handleCancelar = () => {
        setDependencias(undefined);
        setPassoAtual(undefined);
        setRotaFinal("");

        setIsModalOpen(false);
    }
    const handleVoltar = () => {
        setIsPopOpen(false);
        setIsModalOpen(false);
        navigate(passoAtual!.rota);
    }
    const handleProximo = () => {
        mutationVerificarPassoAtual.mutate(passoAtual!.codigo!);
    }
    const handleConcluir = () => {
        mutationVerificarPassoAtual.mutate(passoAtual!.codigo!);
    }

    const estaForaDoGuiaCadastral = passoAtual?.rota !== pathname;//!dependencias?.some(d => d.rota === pathname);
    //Para exibir aviso que esta fora do processo do Guia Cadastral.
    useEffect(() => {
        if (!dependencias)
            setIsPopOpen(true);

        if (dependencias && dependencias.length > 0 && estaForaDoGuiaCadastral)
            setIsPopOpen(true);
    }, [pathname, setIsPopOpen, dependencias, estaForaDoGuiaCadastral]);

    const ModalDependenciasAtual = () => {
        return (
            <>
                <Popover
                    title={
                        <Flex justify="space-between">
                            {estaForaDoGuiaCadastral ? "Parametrização parada." : "Progresso da parametrização"}
                            <Button type="link" style={{ padding: 0 }} onClick={() => setIsPopOpen(false)}>
                                <CloseCircleOutlined style={{ color: "crimson", fontSize: "16px" }} />
                            </Button>
                        </Flex>
                    }
                    content={
                        <Space direction="vertical" style={{ width: '100%' }}>
                            {
                                estaForaDoGuiaCadastral &&
                                <Typography>Deseja cancelar a parametrização que estava em andamento?</Typography>
                            }
                            <Progress percent={Math.round((100 / dependencias!.length) * dependencias!.filter(d => d.feito === true).length)} />
                            <Flex justify="space-between" gap={3}>
                                {
                                    estaForaDoGuiaCadastral &&
                                    <Space>
                                        <Button danger onClick={handleCancelar}>Cancelar</Button>
                                        <Button type="primary" onClick={handleVoltar}>Voltar</Button>
                                    </Space>
                                }
                                {
                                    !estaForaDoGuiaCadastral &&
                                    passoAtual!.codigo !== dependencias!.findLast((d: TypeEntidadeDependencia) => d.feito === false)!.codigo &&
                                    <Button type="primary" onClick={handleProximo} loading={mutationVerificarPassoAtual.isPending}>Proxima</Button>
                                }
                                {
                                    !estaForaDoGuiaCadastral &&
                                    passoAtual!.codigo === dependencias!.findLast((d: TypeEntidadeDependencia) => d.feito === false)!.codigo &&
                                    <Button type="primary" onClick={handleConcluir} loading={mutationVerificarPassoAtual.isPending}>Concluir</Button>
                                }
                            </Flex>
                        </Space>
                    }
                    open={isPopOpen}
                >
                    <FloatButton
                        type="primary"
                        style={{ bottom: document.getElementsByClassName("btnAjuda").length > 0 ? 96 : 48 }}
                        badge={{ count: `${dependencias?.filter(d => d.feito === true).length}/${dependencias!.length}` }}
                        icon={<FileSyncOutlined />}
                        onClick={showModal}
                        onMouseEnter={() => setIsPopOpen(true)}
                        onMouseLeave={() => setTimeout(() => {
                            setIsPopOpen(false)
                        }, 3000)}
                    />
                </Popover>
                <Modal
                    title={estaForaDoGuiaCadastral ? "Parametrização parada." : "Progresso da parametrização"}
                    open={isModalOpen}
                    footer={(_, { OkBtn, CancelBtn }) => <>
                        <Flex gap={5} justify="space-between">
                            <Button onClick={handleFechar}>Fechar</Button>
                            <Flex gap={5} justify="space-between">
                                <Button danger onClick={handleCancelar}>Cancelar</Button>
                                {
                                    estaForaDoGuiaCadastral &&
                                    <Button type="primary" onClick={handleVoltar}>Voltar</Button>
                                }
                                {
                                    !estaForaDoGuiaCadastral &&
                                    passoAtual!.codigo !== dependencias?.findLast((d: TypeEntidadeDependencia) => d.feito === false)?.codigo &&
                                    <Button type="primary" onClick={handleProximo} loading={mutationVerificarPassoAtual.isPending}>Proxima</Button>
                                }
                                {
                                    !estaForaDoGuiaCadastral &&
                                    passoAtual!.codigo === dependencias?.findLast((d: TypeEntidadeDependencia) => d.feito === false)?.codigo &&
                                    <Button type="primary" onClick={handleConcluir} loading={mutationVerificarPassoAtual.isPending}>Concluir</Button>
                                }
                            </Flex>
                        </Flex>
                    </>}>
                    <>
                        {
                            estaForaDoGuiaCadastral &&
                            <Typography>Deseja cancelar a parametrização que estava em andamento?</Typography>
                        }
                        {
                            !estaForaDoGuiaCadastral &&
                            <Typography>Consulte as telas que ainda precisam ser parametrizadas abaixo:</Typography>
                        }
                        <Progress percent={Math.round((100 / dependencias!.length) * dependencias!.filter(d => d.feito === true).length)} />
                        <Steps
                            style={{ marginTop: 16, maxHeight: '300px', overflow: 'auto' }}
                            direction="vertical"
                            items={dependencias?.map(d => {
                                return {
                                    title: d.descricao,
                                    status: d.feito ? "finish" : "process"
                                }
                            })}
                        />
                    </>
                </Modal>
            </>
        );
    }

    return (
        <>
            {
                (!isFetchingTela && dataTela &&
                    dataTela.data.length > 0 &&
                    dataTela.data.some(d => d.feito === false)) && !dependencias &&
                <ModalDependenciasTela dependencias={dataTela.data} exibePopOver={true} />
            }
            {
                dependencias && dependencias.length > 0 &&
                <ModalDependenciasAtual />
            }
        </>

    );
}